import { render, staticRenderFns } from "./WorkspaceStepBuilderPage.vue?vue&type=template&id=ff168694&scoped=true"
import script from "./WorkspaceStepBuilderPage.vue?vue&type=script&lang=ts"
export * from "./WorkspaceStepBuilderPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff168694",
  null
  
)

export default component.exports